import React from 'react';
import { formatLastRun } from '@/experiences/sales-portal/domain/pricing-agent/screens/utils/format-last-run';
import { Typography } from '@usepepper/ui/atoms/typography';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  lastCompletedAt: string | null;
}

export const AgentLastRunLabel: React.FC<Props> = ({ lastCompletedAt }) => {
  const theme = useTheme();
  const label = formatLastRun(lastCompletedAt);

  if (!label) {
    return null;
  }

  return (
    <Typography
      color={theme.sk.color.text.tertiary}
      numberOfLines={1}
      testID="agent-last-run-label"
      variant="paragraph-sm"
    >
      {label}
    </Typography>
  );
};
